import { FC } from "react";
import { useTranslation } from "react-i18next";

import {
  DateTemplate,
  DropdownBoundTemplate,
  GroupTitleTemplate,
  MuiAlert,
  MultiselectBoundTemplate,
  NumberTemplate,
} from "@ryde/controls";

interface IBulkCloneFormProps {
  isOneRideSelected: boolean;
}

export const BulkCloneForm: FC<IBulkCloneFormProps> = ({
  isOneRideSelected,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <GroupTitleTemplate
        name="DUPLICATION_TIME_RANGE"
        formLabel={t("ride.formLabel.DUPLICATION_TIME_RANGE")}
      />
      {/*TODO in future ticket*/}
      {/*<GroupTitleDescriptionStyled>*/}
      {/*  {t("ride.DUPLICATION_TIME_RANGE_DESCRIPTION")}*/}
      {/*</GroupTitleDescriptionStyled>*/}
      <DateTemplate name="dateFrom" formLabel={t("general.FROM")} />
      <DateTemplate name="dateTo" formLabel={t("general.TO")} />

      <GroupTitleTemplate
        name="ALLOWED_DAYS_FOR_RIDE_DUPLICATION"
        formLabel={t("ride.formLabel.ALLOWED_DAYS_FOR_RIDE_DUPLICATION")}
      />
      {/*TODO in future ticket*/}
      {/*<GroupTitleDescriptionStyled>*/}
      {/*  {t("ride.ALLOWED_DAYS_FOR_RIDE_DUPLICATION_DESCRIPTION")}*/}
      {/*</GroupTitleDescriptionStyled>*/}
      <MultiselectBoundTemplate
        name="dayGroup"
        formLabel={t("dayGroup.single")}
        formAttributes={{
          dropItemsSource: "dayGroup",
          dropItemsDisableAdd: true,
        }}
      />
      <MultiselectBoundTemplate
        name="dayType"
        formLabel={t("dayType.single")}
        formAttributes={{
          dropItemsSource: "dayType",
          dropItemsDisableAdd: true,
        }}
      />

      <GroupTitleTemplate
        name="NUMBER_OF_DUPLICATION_PER_EACH_DAY"
        formLabel={t("ride.formLabel.NUMBER_OF_DUPLICATION_PER_EACH_DAY")}
      />
      {/*TODO in future ticket*/}
      {/*<GroupTitleDescriptionStyled>*/}
      {/*  {t("ride.NUMBER_OF_DUPLICATION_PER_EACH_DAY_DESCRIPTION")}*/}
      {/*</GroupTitleDescriptionStyled>*/}
      <NumberTemplate
        name="numberOfDuplicates"
        formLabel={t("ride.NUMBER_OF_DUPLICATES")}
      />

      <GroupTitleTemplate
        name="JOURNEY"
        formLabel={t("ride.formLabel.JOURNEY")}
      />
      {/*TODO in future ticket*/}
      {/*<GroupTitleDescriptionStyled>*/}
      {/*  {t("ride.JOURNEY_DESCRIPTION")}*/}
      {/*</GroupTitleDescriptionStyled>*/}
      {!isOneRideSelected && (
        <MuiAlert severity="info">
          {t("ride.A_JOURNEY_ID_CAN_ONLY_APPLY_ON_1_SOURCE_RIDE")}
        </MuiAlert>
      )}
      <DropdownBoundTemplate
        name="journeyId"
        formAttributes={{
          disabled: !isOneRideSelected,
          dropItemsDisableAdd: !isOneRideSelected,
          dropItemsSource: "journey",
          dropDownTemplate: "{{value}} | {{label}}",
        }}
      />
    </>
  );
};
